










import { Component } from "vue-property-decorator";
import Header from "@/components/header/OLoginHeader.vue";
import ContentList from "@/components/material/MaterialGroups.vue";
import Footer from "@/components/Footer.vue";
import CheckOrganizationAdminLogin from "@/utils/CheckOrganizationAdminLogin";

@Component({
  components: {
    Header,
    ContentList,
    Footer,
  },
})
export default class OContents extends CheckOrganizationAdminLogin {}
